import { render, staticRenderFns } from "./UploadSlide.vue?vue&type=template&id=8e2033da&scoped=true"
import script from "./UploadSlide.vue?vue&type=script&lang=js"
export * from "./UploadSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2033da",
  null
  
)

export default component.exports